import checkoutSlice from "./checkoutSlice";

export default checkoutSlice.reducer;
export { default as checkoutSlice } from "./checkoutSlice";
